import React from 'react';
import styles from './BillDetail.module.scss';
import {EditIcon, TrashIcon} from '../../../../../components/style-guide/icons';
import PropTypes from 'prop-types';
import {emptyFn} from "../../../../../shared";
import InlineBox from '../../../../../components/style-guide/box/InlineBox';
import Box from '../../../../../components/style-guide/box/Box';
import {ResponsiveLayout} from '../../../../../components/style-guide/responsive-layout/ResponsiveLayout';
import clsx from 'clsx';


export const BillDetailMobile = props => {
  const {onEdit, billInfo, onRemove} = props;
  return (
    <Box className={styles.billContainerMobile}>
      <InlineBox className="py-1 px-2">
        <span className={clsx("flex-fill" )}>Estás haciendo una compra como <b>Empresa</b></span>
        <span className={clsx(styles.actionMobile)} onClick={onEdit}>
          <EditIcon fontSize="small" className="extra-primary"/>
          <span className="ml-2">Editar</span>
        </span>
      </InlineBox>
      <InlineBox className="py-1 px-2">
        <span className={clsx("flex-fill" )}>¿Es una compra personal?</span>

        <span className={styles.actionMobile} onClick={onRemove}>
          <TrashIcon fontSize="small" className="extra-primary"/>
          <span className="ml-1">Eliminar</span>
        </span>
      </InlineBox>
      <div className="w-100 p-2"><b>{billInfo.businessType} ({billInfo.rut})</b></div>
    </Box>
  );
};

export const BillDetailDesktop = props => {

  const {onEdit, billInfo, onRemove} = props;

  return (
    <div className={styles.billDetailContainer}>
      <div className={styles.companyDetailContainer}>
        <span className={styles.title}>Estás haciendo una compra como <span>Empresa </span>
        <span onClick={onEdit}><EditIcon fontSize="small" className="extra-primary"/>&nbsp;Editar</span></span>
        <span className={styles.company}>{billInfo.businessType}({billInfo.rut})</span>
      </div>
      <div className={styles.personalBoxContainer}>
        <span>¿Es una compra personal?</span>
        <span className={styles.deleteMessage} onClick={onRemove}>
          <TrashIcon fontSize="small" className="extra-primary"/>
          <span>Eliminar los datos de la empresa</span>
        </span>
      </div>
    </div>
  );
};

export const BillDetail = props => {
  return <ResponsiveLayout MobileComponent={BillDetailMobile} DesktopComponent={BillDetailDesktop} {...props} />
};

BillDetail.propTypes = {
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

BillDetail.defaultProps = {
  onEdit: emptyFn(),
  onRemove: emptyFn(),
};

export default BillDetail;
